<template>
	<div class="bg-white px-3 index" style="margin: 0 26px;margin-bottom: 0!important;">
		<div class="scbtn_b">
			<el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">
				上传视频
			</el-button>
		</div>
		<div class="add_tits" ref="titles">
			<el-form class="form-inlines u-f u-jsb" :inline="true">
				<div>
					<!-- <el-form-item label="类型">
						<el-cascader v-model="lb_value" size="small" :props="lb_props" :options="lb_options">
						</el-cascader>
					</el-form-item>
					<el-form-item label="人员">
						<el-select v-model="search_ry" clearable placeholder="请选择" size="small" filterable>
							<el-option v-for="item in  ry_options" :key="item.id" :label="item.nickname"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="名称">
						<el-input v-model="keyword" size="small" placeholder="请输入内容"></el-input>
					</el-form-item>
					<el-form-item label="时间">
						<el-date-picker v-model="times" size="small" type="daterange" value-format="yyyy-MM-dd"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item class="search_b">
						<el-button type="primary" icon="el-icon-search" size="small" @click="begin">查询</el-button>
					</el-form-item>

				</div>

			</el-form>
		</div>
		<div class="ibox-content">
			<el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
				<el-table-column prop="id" label="视频编号" width="80"></el-table-column>
				<el-table-column prop="style" label="视频样式">
					<template slot-scope="scope">
						<span>{{({1:'横屏',2:'竖屏'})[scope.row.style]}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="视频标题" show-overflow-tooltip></el-table-column>
				<el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
				<el-table-column prop="create_time" label="状态" show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.is_examine==0">待审核</span>
						<span v-else-if="scope.row.is_examine==1" style="color:green">审核通过</span>
						<span v-else-if="scope.row.is_examine==2" style="color:red">审核未通过</span>
					</template>
				</el-table-column>

				<!-- <el-table-column prop="content" label="视频封面">
					<template slot-scope="scope">
						<div class="u-f u-wrap">
							<div v-for="(item,index) in scope.row.cover_map" :key="index" @click="goprev(item)">
								<img :src="item.url" alt="" width="50">
							</div>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="refuse_remark" label="拒绝理由" show-overflow-tooltip></el-table-column>
				<el-table-column prop="bonus" label="已打赏" width="70"></el-table-column>
				<el-table-column prop="bonus" label="详细" width="85">
					<template slot-scope="{row}">
						<el-button type="text" @click="opxxdateil(row)">详细数据</el-button>
					</template>
				</el-table-column> -->
				<el-table-column label="操作" width="350" align="center" fixed="right">
					<template slot-scope="scope">
						<!-- <el-button size="mini" type="info" v-if="scope.row.is_top!=1" @click="handle_top(scope.row,1)">
							置顶
						</el-button>
						<el-button size="mini" type="primary" v-else plain @click="handle_top(scope.row,0)">取消置顶
						</el-button>-->
						<el-button size="mini" type="warning" @click="handleexam(scope.$index, scope.row)">预览
						</el-button>
						<el-button size="mini" type="primary" icon="el-icon-edit-outline"
							@click="handleEdit(scope.row,scope.$index)"></el-button>
						<el-button size="mini" type="danger" icon="el-icon-delete"
							@click="handleDelet(scope.row,scope.$index)"></el-button>
						<!-- <el-button size="mini" type="info" @click="handle_ds(scope.row)" v-if="scope.row.create_user">
							打赏
						</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="上传视频" :visible.sync="dialogVisible" center top="20px" width="70%" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content scshipin">
				<el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px"
					class="demo-ruleForm forms-lines">
					<!-- <el-form-item label="人员" prop='ry_value'>
						<el-select v-model="ruleForm.ry_value" clearable placeholder="请选择" size="small" filterable>
							<el-option v-for="item in  ry_options" :key="item.id" :label="item.nickname"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item> -->
					<!-- <el-form-item label="视频类别" prop='lb_value'>
						<el-cascader v-model="ruleForm.lb_value" size="small" :props="lb_props" :options="lb_options">
						</el-cascader>
					</el-form-item> -->
					<el-form-item label="视频名称" prop='lb_title'>
						<el-input v-model="ruleForm.lb_title" size="small" maxlength="20" placeholder="最多输入20个字"></el-input>
					</el-form-item>
					<!-- <el-form-item label="关键词">
						<div class="u-f u-ac">
							<el-input v-model="ruleForm.keyword" size="small" placeholder="用顿号分割(、)"></el-input>
							<el-tag type="success">用顿号分割(、)</el-tag>
						</div>
					</el-form-item> -->
					<!-- <el-form-item label="描述">
						<div class="u-f u-ac">
							<el-input v-model="ruleForm.describe" type="textarea" :rows="3" size="small"
								placeholder="视频描述"></el-input>
						</div>
					</el-form-item> -->
					<el-form-item label="视频样式" required>
						<el-radio-group v-model="ruleForm.hs_radio">
							<el-radio :label="1">横屏</el-radio>
							<el-radio :label="2">竖屏</el-radio>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="视频封面">
						<el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
							:headers="{ token:$store.state.user.token }" :data="{ image_class_id:'72' ,file_type:'1'}"
							:file-list="ruleForm.lb_mapList" :on-success="uploadSuccess" :limit='1'
							list-type="picture-card">
							<i class="el-icon-plus"></i>
						</el-upload>
						<span>注：如横屏视频请上传长方形图片作为封面，如竖屏视频请上传正方形图片作为封面，也可不传自动截取</span>
					</el-form-item>
					<el-form-item label="视频上传" required>
						<!-- <el-upload action="/admin/uploadFile" name="img" ref="uploads"
							:headers="{ token:$store.state.user.token }" :data="{ image_class_id:'72',file_type:'2' }"
							:file-list="ruleForm.lb_fileList" :on-success="uploadSuccessed" :limit='1'
							:on-preview="uploadPrev">
							<el-button size="small" type="primary">点击上传</el-button>
						</el-upload> -->
						<Upload ref="cmps" v-on:uploaded="getupload" :key="company" v-on:Delfile="Delfile"></Upload>
						<div v-for="(item, index) in filename" :key="index">
							<a :href="`${item.url}`" target="_blank">{{ item.name}}</a>
							<i class="el-icon-circle-close close" @click="deletefile(filename, index)"></i>
						</div>
					</el-form-item>
					<el-form-item label="视频描述" prop="lb_content">
						<el-input v-model="ruleForm.lb_content" type="textarea" :rows="3" size="small" 
							placeholder="最多输入40个字" maxlength="40"></el-input>
					</el-form-item>
					<el-form-item label="请选择观看价格">
						<div class="jgbtns">
							<div class="u-f ">
								<el-button :class='{selectss:selectindex==index}' @click="selectjg(j,index)"
									v-for="(j,index) in jgs" :key="index">{{j.text}}</el-button>
							</div>
						</div>
						<div v-if="selectindex==5">
							<el-input v-model="ruleForm.price" min="1" style="max-width:20%" type="number" size="small"
								placeholder="请输入自定义价格"></el-input>
						</div>
					</el-form-item>

					<el-form-item label="发布设置" prop='lb_put'>
						<el-radio-group v-model="ruleForm.lb_put">
							<el-radio label="1" style="width:100%;margin-bottom:0px">立即发布</el-radio>
							<div style="margin:5px 0">
								<el-radio label="2">定时发布</el-radio>
								<el-date-picker v-model="ruleForm.lb_dstime" :clearable="false"
									:disabled="ruleForm.lb_put==2?false:true" size="mini" type="datetime"
									value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间" default-time="12:00:00">
								</el-date-picker>
							</div>
							<el-radio label="3" style="width:100%">保存草稿</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="submit('ruleForm')" size="small" type="primary" class="tjben" :loading="subloading">提 交</el-button>
				<el-button @click="dialogVisible = false" size="small">取 消</el-button>
			</span>
		</el-dialog>
		<!--  -->
		<el-dialog :visible.sync="dialog_prev" width="60vw" top="5vh">
			<div style="margin: -60px -20px -30px -20px;">
				<img :src="urls" class="w-100" />
			</div>
		</el-dialog>
		<!-- 视频 -->
		<el-dialog :visible.sync="dialog_video" width="60vw" top="5vh">
			<div style="margin: -60px -20px -30px -20px;">
				<video width="100%" height="500" controls>
					<source :src="video_url">
				</video>
			</div>
		</el-dialog>
		<!-- 审核 -->
		<el-dialog title="审核" :visible.sync="examdialogs" top="40px" width="70%" center class="dialogs"
			@close='closeexam'>
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-form :model="examForm" :rules="rule" ref="examForm" label-width="150px" v-loading='examloading'
					class="demo-ruleForm forms-lines">
					<el-form-item label="标题：" prop='ry_value'>
						<span>{{examForm.name}}</span>
					</el-form-item>
					<el-form-item label="内容：" prop='ry_value'>
						<div>
							<video width="80%" height="500" v-if="examdialogs&&examForm.content" controls>
								<source :src="examForm.content">
							</video>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="examdialogs = false" size="small">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="打赏" :visible.sync="dsdialogs" top="150px" width="40%" center class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-form :model="dsForm" ref="dsForm" label-width="150px" v-loading='dsloading'
					class="demo-ruleForm forms-lines">
					<el-form-item label="标题：">
						<span>{{dsForm.name}}</span>
					</el-form-item>
					<el-form-item label="创作人：">
						<span>{{dsForm.create_user_text}}</span>
					</el-form-item>
					<el-form-item label="创作时间：">
						<span>{{dsForm.create_time}}</span>
					</el-form-item>
					<el-form-item label="共打赏金额：">
						<span>{{dsForm.bonus}}</span>
					</el-form-item>
					<el-form-item label="打赏：">
						<el-input v-model="ds_mon_value" size="small" style="width:100px" type="number" min="0"
							placeholder="请输入打赏金额">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dssubmit()" size="small" type="primary" :loading="subloading">提 交</el-button>
				<el-button @click="dsdialogs = false" size="small">取 消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="详细数据总览" :visible.sync="xxdialogs" top="120px" width="70%" center class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content" v-loading='tableDatadsloading'>
				<el-row>
					<el-col :span="12">
						<div class="ibox-content">
							<el-table :data="tableDatads" border v-loading="loading" :height="heightds"
								class="tableLimit">
								<el-table-column prop="user.nickname" label="打赏人">
									<template slot-scope="{row}">
										<div class="u-f u-ac">
											<div class="ava">
												<el-image style="width: 50px; height: 50px" class="ava_img"
													:src="row.user.avatar" :fit="'cover'">
												</el-image>
											</div>
											<div class="mar_left">{{row.user.nickname}}</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="reward_amount" label="打赏金额"></el-table-column>
								<el-table-column prop="create_time" label="打赏时间"></el-table-column>
							</el-table>

						</div>
					</el-col>
					<el-col :span="12">
						<div class="">
							<el-form :model="xxdatas" ref="xxdatas" label-width="150px" v-loading='dsloading'
								class="demo-ruleForm forms-lines">
								<el-form-item label="浏览量：">
									<span>{{xxdatas.click}}</span>
								</el-form-item>
								<el-form-item label="点赞量：">
									<span>{{xxdatas.praise}}</span>
								</el-form-item>
								<el-form-item label="收藏量：">
									<span>{{xxdatas.collection}}</span>
								</el-form-item>
								<el-form-item label="评论量：">
									<span>{{xxdatas.comment_count}}</span>
								</el-form-item>

							</el-form>
						</div>
					</el-col>
				</el-row>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="xxdialogs = false" size="small">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>


<script>
	import Upload from "../../../components/uploadImg/upload.vue";
	import {
		mapState
	} from 'vuex'
	import tinymce from '@/components/common/tinymce.vue';
	export default {
		components: {
			tinymce,
			Upload
		},
		data() {
			return {
				lb_value: '',
				lb_options: [],
				lb_props: {
					label: "name",
					value: "id",
					children: 'child'
				},
				loading: false,
				tableData: [],
				count: 0,
				currentPage: 1,
				pagesize: 15,
				height: null,
				// 
				eid: '0',
				dialogVisible: false,
				subloading: false,

				ruleForm: {
					lb_title: '',
					lb_value: '',
					lb_content: '',
					lb_sort: 50,
					lb_put: '1',
					lb_dstime: '',
					lb_mapList: [],
					lb_fileList: [],
					keyword: '',
					lb_state: '',
					ry_value: '',
					lb_dz: '',
					lb_ll: '',
					lb_sc: '',
					hs_radio: 2,
					describe: '',
					price: 1
				},
				ry_options: [],
				mapListed: [],
				fileListed: [],
				state_options: [],
				rule: {
					lb_value: [{
						required: true,
						message: '请填写视频类别',
						trigger: 'blur'
					}],
					lb_title: [{
						required: true,
						message: '请填写视频名称',
						trigger: 'blur'
					}],
					lb_sort: [{
						required: true,
						message: '请填写排序',
						trigger: 'blur'
					}],
					lb_put: [{
						required: true,
						message: '请选择发布设置',
						trigger: 'blur'
					}],
					hs_radio: [{
						required: true,
						message: '请选择视频样式',
						trigger: 'blur'
					}],
					lb_content: [{
						required: true,
						message: '请输入视频描述',
						trigger: 'blur'
					}],
				},
				// 
				dialog_prev: false,
				urls: '',
				// 
				dialog_video: false,
				video_url: '',
				examdialogs: false,
				examForm: {
					remark: '',
					examradio: '',
					content: '',
					name: '',
				},
				examloading: false,

				dsForm: {},
				dsdialogs: false,
				dsloading: false,
				ds_mon_value: 0,
				company: 1,
				filename: [],
				file1: [],
				videoindex: 1,
				uploading: false,
				search_ry: '',
				times: [],
				xxdialogs: false,
				heightds: null,
				tableDatadsloading: false,
				tableDatads: [],
				xxdatas: {},
				keyword: '',
				jgs: [{
						id: 1,
						text: '免费'
					},
					{
						id: 2,
						text: '9.9'
					},
					{
						id: 3,
						text: '29.9'
					},
					{
						id: 4,
						text: '59.9'
					},
					{
						id: 5,
						text: '99.9'
					},
					{
						id: 6,
						text: '自定义'
					},
				],
				selectindex: 0
			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			let that = this
			that.getHeight()
			that.getlbxx()
			that.getstate()
			that.getper()
			that.begin()
		},
		methods: {
			getHeight() {
				let that = this
				var titles = that.$refs.titles.offsetHeight
				that.height = window.innerHeight - titles - 250 + 'px'
				that.heightds = window.innerHeight - 400 + 'px'
				window.onresize = () => {
					var titles = that.$refs.titles.offsetHeight
					that.height = window.innerHeight - titles - 250 + 'px'
					that.heightds = window.innerHeight - 400 + 'px'
				}
			},
			// 搜索
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 15
				that.search()
			},
			search() {
				let that = this
				that.tableData = []
				that.loading = true
				axios.post("/admin/health/list", {
						keyword: this.keyword,
						page: that.currentPage,
						page_count: that.pagesize,
						health_category_id: that.lb_value[that.lb_value.length - 1],
						type: '2',
						start_time: this.times ? this.times[0] : '',
						end_time: this.times ? this.times[1] : '',
						user_id: this.search_ry,

					}, {
						token: true
					})
					.then(response => {
						that.loading = false
						that.tableData = response.data.data.list
						that.count = response.data.data.totalCount
					})
					.catch(error => {})
			},
			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},
			handleAdd() {
				let that = this
				that.dialogVisible = true
				that.eid = '0'
				this.company += 1
				that.form_clear()
			},
			form_clear() {
				let that = this
				that.ruleForm.lb_title = ''
				that.ruleForm.lb_value = ''
				that.ruleForm.lb_content = ''
				that.ruleForm.lb_put = '1'
				that.ruleForm.lb_dstime = ''
				that.ruleForm.lb_mapList = []
				that.ruleForm.lb_sort = 50
				that.mapListed = []
				that.ruleForm.lb_fileList = []
				that.fileListed = []
				that.ruleForm.lb_state = ''
				that.ruleForm.keyword = ''
				that.ruleForm.ry_value = ''
				this.ruleForm.ry_value = ''
				this.ruleForm.lb_dz = ''
				this.ruleForm.lb_ll = ''
				this.ruleForm.lb_sc = ''
				this.ruleForm.describe = ''
				this.ruleForm.hs_radio = 2
				this.file1 = []
				this.filename = []

			},
			// 获取人员
			getper() {
				let that = this
				axios
					.post(`/admin/doctorAssistantList`, {}, {
						token: true
					})
					.then(response => {
						that.ry_options = response.data.data
					})
					.catch(error => {})
			},
			selectjg(j, i) {
				this.selectindex = i
			},
			submit(formName) {
				let that = this
				var time;
				if (that.ruleForm.lb_put == '1') {
					time = that.gettimes()
				} else if (that.ruleForm.lb_put == '2') {
					time = that.ruleForm.lb_dstime
				} else {
					time = that.ruleForm.lb_put
				}
				that.file1 = that.file1.concat(that.filename);
				that.$refs[formName].validate((valid) => {
					if (valid) {
						// if (that.mapListed.length < 1) return that.$message.error('请上传视频封面');
						if (that.file1.length < 1) return that.$message.error('请上传视频');
						if (this.selectindex == 5 && (this.ruleForm.price == '' || this.ruleForm.price == 0))
							return this.$message.error('自定义金额有误')
						that.subloading = true
						let prices
						if (this.selectindex != 5) {
							prices = this.jgs[this.selectindex].text == '免费' ? 0 : this.jgs[this.selectindex].text
						} else {
							prices = this.ruleForm.price
						}
						let urls;
						if (this.eid && this.eid != '0') {
							urls = "/admin/health/update"
						} else {
							urls = "/admin/health/save"
						}
						axios.post(urls, {
								id: that.eid,
								health_category_id: Array.isArray(that.ruleForm.lb_value) ? that.ruleForm
									.lb_value[that.ruleForm.lb_value.length - 1] : that.ruleForm.lb_value,
								name: that.ruleForm.lb_title,
								content: that.ruleForm.lb_content,
								sort: that.ruleForm.lb_sort,
								cover_map: that.mapListed,
								file: that.file1,
								to_show: that.ruleForm.lb_put,
								show_time: time,
								author: this.user.id,
								type: '2',
								keyword: this.ruleForm.keyword,
								statement: that.ruleForm.lb_state,
								create_user: that.ruleForm.ry_value,
								base_browse: this.ruleForm.lb_ll,
								base_praise: this.ruleForm.lb_dz,
								base_collection: this.ruleForm.lb_sc,
								is_examine: 0,
								style: this.ruleForm.hs_radio,
								describe: this.ruleForm.describe,
								price: prices

							}, {
								token: true
							})
							.then(response => {
								that.subloading = false
								if (response.data.code == '200') {
									that.dialogVisible = false
									that.search()
								} else {
									that.$message.error(response.data.msg);
								}
							})
							.catch(error => {
								that.subloading = true
							})
					} else {
						this.$alert("信息遗漏未填")
						return false;
					}
				});
			},
			// 编辑
			handleEdit(row, index) {
				let that = this
				that.form_clear()
				that.dialogVisible = true
				that.eid = row.id
				this.company += 1
				axios
					.post("/admin/health/read", {
						id: that.eid,
					}, {
						token: true
					})
					.then(response => {
						var data = response.data.data
						that.ruleForm.lb_value = data.health_category_id
						that.ruleForm.keyword = data.keyword
						that.ruleForm.lb_title = data.name
						that.ruleForm.lb_content = data.content
						that.ruleForm.lb_mapList = data.cover_map ? data.cover_map : []
						that.mapListed = data.cover_map ? data.cover_map : []
						that.ruleForm.lb_fileList = data.file
						that.fileListed = data.file
						that.filename = data.file
						that.ruleForm.lb_put = data.to_show ? data.to_show.toString() : ''
						if (data.to_show == '2') {
							that.ruleForm.lb_dstime = data.show_time
						}
						that.ruleForm.lb_sort = data.sort
						that.ruleForm.lb_state = data.statement
						that.ruleForm.ry_value = data.create_user ? data.create_user : ''
						that.ruleForm.lb_ll = data.base_browse
						that.ruleForm.lb_dz = data.base_praise
						that.ruleForm.lb_sc = data.base_collection
						that.ruleForm.describe = data.describe
						this.ruleForm.hs_radio = data.style - 0
						if (data.price == 0) {
							this.selectindex = 0
						} else if (data.price > 0) {
							let jgindex = ''
							this.jgs.forEach((e, index) => {
								if (data.price == e.text) {
									jgindex = index
								}
							})
							if (jgindex != '') {
								this.selectindex = jgindex
							} else {
								this.selectindex = 5
								this.ruleForm.price = data.price
							}
						}


					})
					.catch(error => {})
			},
			// 删除
			handleDelet(row, index) {
				let that = this
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios
						.post("/admin/health/del", {
							id: row.id,
						}, {
							token: true
						})
						.then(response => {
							if (response.data.code == '200') {
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								that.search()
							} else {
								that.$message.error(response.data.msg);
							}
						})
						.catch(error => {})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			gettimes() {
				let nowDate = new Date();
				let year = nowDate.getFullYear();
				let month = nowDate.getMonth() + 1;
				let day = nowDate.getDate();
				let hour = nowDate.getHours(); //获取系统时，
				let min = nowDate.getMinutes(); //分
				let sec = nowDate.getSeconds(); //秒
				month = month > 9 ? month : '0' + month
				day = day > 9 ? day : '0' + day
				hour = hour > 9 ? hour : '0' + hour
				min = min > 9 ? min : '0' + min
				sec = sec > 9 ? sec : '0' + sec
				return `${year}-${month}-${day} ${hour}:${min}`;
			},
			// 类别
			getlbxx() {
				let that = this
				axios
					.post("/admin/healthCategory/categoryHead", {
						noChild: 1
					}, {
						token: true
					})
					.then(response => {
						that.lb_options = response.data.data
					})
					.catch(error => {})
			},
			// 声明
			getstate() {
				let that = this
				axios
					.post("/admin/getContentBySysTypeId", {
						sys_id: 1,
						type_id: 22
					}, {
						token: true
					})
					.then(response => {
						that.state_options = response.data.data
					})
					.catch(error => {})
			},
			goprev(item) {
				let that = this
				that.dialog_prev = true
				that.urls = item.url
			},
			// 
			uploadPrev(file) {
				let that = this
				that.dialog_video = true
				if (file.url) {
					that.video_url = file.url
				}
			},
			// 上传封面
			uploadSuccess(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.mapListed = []
				that.mapListed.push(response.data)
			},
			//上传文件
			uploadSuccessed(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.uploads;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.fileListed = []
				that.fileListed.push(response.data)
				that.$message({
					message: '上传成功',
					type: 'success'
				});
			},
			handleexam(index, row) {
				this.examdialogs = true
				this.eid = row.id
				this.examloading = true
				this.videoindex++
				axios
					.post("/admin/health/read", {
						id: this.eid,
					}, {
						token: true
					})
					.then(response => {
						this.examloading = false
						var data = response.data.data
						this.examForm.name = data.name
						this.examForm.remark = data.refuse_remark
						this.examForm.examradio = data.is_examine
						this.examForm.content = data.file[0].url

					})
					.catch(error => {})
			},
			closeexam() {
				this.examForm.content = ''
			},
			handle_top(row, val) {
				axios
					.post("/admin/pc/health_headlines/edit_top", {
						id: row.id,
						is_top: val
					}, {
						token: true
					})
					.then(response => {
						if (response.data.code == '200') {
							this.$message({
								type: 'success',
								message: '操作成功!'
							});
							this.search()
						} else {
							this.$message.error(response.data.message);
						}
					})
					.catch(error => {})
			},
			examsubmit() {
				if (this.examForm.examradio == 2 && this.examForm.remark == '') {
					this.$message({
						message: '请输入拒绝理由',
						type: 'warning'
					});
					return
				}
				this.examloading = true
				axios
					.post("/admin/pc/health_headlines/set_examine", {
						id: this.eid,
						refuse_remark: this.examForm.remark,
						type: this.examForm.examradio,
						time: 0
					}, {
						token: true
					})
					.then(response => {
						if (response.data.code == 200) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.examdialogs = false
							this.search()
						} else {
							this.$message({
								message: response.data.msg,
								type: 'warning'
							});
						}
						this.examloading = false
					})
					.catch(error => {})
			},
			handle_ds(item) {
				this.dsForm = item
				this.ds_mon_value = 0
				this.dsdialogs = true

			},
			dssubmit() {
				if (!this.ds_mon_value || this.ds_mon_value <= 0) return this.$message.error('金额必填且必须大于0')
				this.dsloading = true
				axios
					.post("/admin/pc/CapitalDetails/grantBonus", {
						source: 3,
						grantee_id: this.dsForm.create_user,
						grantee_type: this.dsForm.customer_type,
						price: this.ds_mon_value,
						data_id: this.dsForm.id,
					}, {
						token: true
					})
					.then(response => {
						if (response.data.code == 200) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.dsdialogs = false
							this.search()
						} else {
							this.$message({
								message: response.data.msg,
								type: 'warning'
							});
						}
						this.dsloading = false
					})
					.catch(error => {})
			},
			getupload(val) {
				this.file1.push(val.data);
			},
			Delfile(val) {
				let ind = -1
				if (this.file1.length > 0) {
					this.file1.forEach((e, i) => {
						if (e.name == val) {
							ind = i
							this.$refs.cmps.is_success--
						}
					})
				}
				this.file1.splice(ind, 1)
			},
			// 删除单条文件
			deletefile(item, index) {
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// this.search()
					this.filename.splice(index, 1)
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			updatelist() {
				let that = this
				this.$confirm('此操作将更新pc端视频页面, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.uploading = true
					axios
						.get("/admin/pc/createStaticHtml?source=1&type=2&page=1&time=0", {
							headers: {
								token: sessionStorage.getItem('token')
							}
						})
						.then(response => {
							if (response.data.code == '200') {
								this.$message({
									type: 'success',
									message: '更新成功!'
								});
							} else {
								that.$message.error(response.data.msg);
							}
							this.uploading = false
						})
						.catch(error => {})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			opxxdateil(r) {
				this.xxdialogs = true
				this.tableDatadsloading = true
				axios
					.post("/admin/pc/health_headlines/articleDetail", {
						id: r.id,
					}, {
						token: true
					})
					.then(response => {
						if (response.data.code == 200) {
							this.tableDatadsloading = false
							this.xxdatas = response.data.data
							this.tableDatads = response.data.data.RewardRecord

						}
					})
					.catch(error => {})
			}
		},
		watch: {
			'examForm.examradio'(val, old) {
				if (val == 1) {
					this.examForm.remark = ''
				}
			}
		}

	};
</script>

<style lang='scss' scoped>
	.el-button--primary {
		color: #fff;
		background-color: #5473e8;
		border-color: #5473e8;
	}

	.search_b {
		margin-left: 50px;
	}

	.index {
		border-radius: 6px;
	}

	.scbtn_b {
		padding-top: 17px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.jgbtns {

		.selectss {
			color: teal;
			border-color: #b3d9d9;
			background-color: #e6f2f2;
		}
	}
	.scshipin{
		.el-form-item{
			margin-bottom: 24px !important;
		}
	}
	.tjben{
		// background-color: #23bcca;
		// border-color: #23bcca;
	}
	/deep/.el-dialog__title{
		font-size: 16px !important;
	}
	/deep/.dialog-footer {
            .el-button--primary {
                background-color: #23bcca;
                border-color: #23bcca;
            }
        }
</style>